import styled from 'styled-components';

const Wrapper = styled.div`
  height: 80px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
